export default "__VITE_ASSET__BziKiSLM__"